import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2, AlertCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function submit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { username: u, password: p });
      localStorage.setItem("hireflow_admin_token", res.data.token);
      nav("/admin/dashboard");
    } catch (err) {
      setError(err?.response?.data?.detail || "Σφάλμα σύνδεσης");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      {/* Left: form */}
      <div className="flex items-center justify-center px-6 py-10 bg-slate-50">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-2 text-blue-700 text-xs font-bold tracking-[0.2em] uppercase mb-3">
            <span className="inline-block w-8 h-px bg-blue-700"></span>
            HireFlow · Admin
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight text-slate-900">Σύνδεση Διαχειριστή</h1>
          <p className="text-slate-500 font-medium mt-3">
            Εισάγετε τα διαπιστευτήριά σας για να διαχειριστείτε τη λίστα ΑΦΜ και τις υποβολές.
          </p>

          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="admin-login-form">
            <div>
              <label className="hf-label">Όνομα Χρήστη</label>
              <input data-testid="admin-username-input" className="hf-input" value={u} onChange={(e) => setU(e.target.value)} autoFocus />
            </div>
            <div>
              <label className="hf-label">Κωδικός Πρόσβασης</label>
              <input data-testid="admin-password-input" type="password" className="hf-input" value={p} onChange={(e) => setP(e.target.value)} />
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 rounded-xl p-3 text-sm text-red-700 font-semibold flex items-center gap-2" data-testid="login-error">
                <AlertCircle size={16} /> {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full h-14 bg-blue-700 hover:bg-blue-800 text-white font-bold rounded-xl shadow-[0_8px_20px_-8px_rgba(29,78,216,0.5)] transition-all flex items-center justify-center gap-2 disabled:opacity-60"
              data-testid="admin-login-btn"
            >
              {loading ? <Loader2 className="animate-spin" size={20} /> : <Lock size={18} />} Σύνδεση
            </button>
          </form>
        </div>
      </div>

      {/* Right: image */}
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1583338850703-bc602b103674?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhYnN0cmFjdCUyMG9mZmljZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzcxMzM5ODN8MA&ixlib=rb-4.1.0&q=85"
          alt="Architecture"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-blue-900/70 via-blue-700/40 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <p className="text-2xl font-extrabold tracking-tight max-w-md leading-tight">
            «Διαχείριση προσλήψεων με ασφάλεια, αξιοπιστία και χωρίς γραφειοκρατία.»
          </p>
        </div>
      </div>
    </div>
  );
}
